import React from "react";
import "./ActivePolls.scss";
import format from "date-fns/format";
import { Link } from "react-router-dom";

const ActivePolls = ({ polls }) => {
  return (
    <div className="active-polls">
      <div className="active-polls__header-container">
        <p className="active-polls__header">Dashboard</p>
      </div>
      <div className="active-polls__container">
        {polls &&
          polls.map((poll) => {
            return (
              <div className="active-polls__option">
                <div className="active-polls__title-container">
                  <p className="active-polls__title">{poll.title}</p>
                </div>
                {new Date(poll.endDateTime).getTime()  > Date.now() ? <div className="active-polls__date-container">
                  <p className="active-polls__date-end">Ends</p>
                  <p className="active-polls__date">
                    {format(new Date(poll.endDateTime), "MM/dd/yyyy")}
                  </p>
                  <p className="active-polls__at">at</p>
                  <p className="active-polls__time">
                    {format(new Date(poll.endDateTime), "hh:mm a")}
                  </p>
                </div> : <div className="active-polls__date-container">
                  <p className="active-polls__date-end">Ended On</p>
                  <p className="active-polls__date">
                    {format(new Date(poll.endDateTime), "MM/dd/yyyy")}
                  </p>
                  <p className="active-polls__at">at</p>
                  <p className="active-polls__time">
                    {format(new Date(poll.endDateTime), "hh:mm a")}
                  </p>
                </div>}
                <div className="active-polls__link-container">
                  <div className="active-polls__link-top">
                    <Link
                      className="active-polls__edit"
                      to={"/edit/" + poll._id}
                    >
                      Edit 
                    </Link>
                    <Link
                      className="active-polls__result"
                      to={"/results/" + poll._id}
                    >
                      Result
                    </Link>
                  </div>
                  <div className="active-polls__link-bottom">
                    <Link
                      className="active-polls__share"
                      to={"/share/" + poll._id}
                    >
                      Share 
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ActivePolls;
